import { sanitizeHtml } from '../utils/sanitize';

export default {
  install: (app) => {
    app.directive('sanitize', (el, binding) => {
      el.innerHTML = sanitizeHtml(binding.value);
    });
  },
};
